import React, { useEffect, useState } from 'react'
import Collapsible from './Collapsible/Collapsible'
import { AnimatePresence } from 'framer-motion'
import { useCollapsible } from 'client/fragments/listerFragment/components/Filters/Collapsible/useCollapsible'
import { Button, Input } from 'chemistry'
import classNames from 'classnames'
import { dictionary } from 'client/common/accessability'
import { getId } from 'client/fragments/listerFragment/components/Filters/utilsFilters'

const parseRangeValues = active => {
  const [min, max] = active?.[0]?.value?.replace(/"/g, '').split('-') || []
  return { min: min || '', max: max || '' }
}
export function RangeFilterItem({
  id,
  filter: { title, type, name, max: maxRange, min: minRange },
  active,
  toText,
  onChange,
  className,
  filterPosition,
  lang
}) {
  const { min: initialMinVal, max: initialMaxVal } = parseRangeValues(active)
  const [minVal, setMinVal] = useState(initialMinVal)
  const [maxVal, setMaxVal] = useState(initialMaxVal)
  const [isValid, setIsValid] = useState(true)
  useEffect(() => {
    const minNum = minVal ? +minVal : minRange
    const maxNum = maxVal ? +maxVal : maxRange
    setIsValid(minNum < maxNum && minNum >= 0)
  }, [maxRange, maxVal, minRange, minVal])
  useEffect(() => {
    if (active) {
      const { min, max } = parseRangeValues(active)
      setMinVal(min)
      setMaxVal(max)
    } else {
      setMinVal('')
      setMaxVal('')
    }
  }, [active])

  const onSubmit = e => {
    e.preventDefault()
    const minNum = minVal ? +minVal : minRange
    const maxNum = maxVal ? +maxVal : maxRange

    const min = Math.max(minNum, minRange)
    const max = Math.min(maxNum, maxRange)
    const item = { value: `"${min}"-"${max}"` }

    if (minNum < minRange) setMinVal(minRange)
    if (maxNum > maxRange) setMaxVal(maxRange)

    onChange({ item, name, type, title, filterPosition })
  }

  const onMinChange = e => {
    const value = onInputChange(e)
    setMinVal(value)
  }
  const onMaxChange = e => {
    const value = onInputChange(e)
    setMaxVal(value)
  }

  return (
    <form id={id} className={classNames('flex items-center gap-1', className)} onSubmit={onSubmit}>
      <Input
        data-testid={`min-range-${name}`}
        placeholder={`${minRange}`}
        autoComplete='off'
        value={minVal}
        onChange={onMinChange}
        type='number'
        title={dictionary(lang).priceFrom}
      />
      {toText}
      <Input
        data-testid={`max-range-${name}`}
        placeholder={`${maxRange}`}
        autoComplete='off'
        value={maxVal}
        onChange={onMaxChange}
        type='number'
        title={dictionary(lang).priceTo}
      />
      <Button
        _hover={{
          background: 'red.600'
        }}
        disabled={!isValid}
        onClick={onSubmit}
        data-testid={`submit-range-${name}`}
        variant='circleSmall'
        background='red.500'
        color='white'
        borderWidth={0}
        borderRadius='8px'
        title={dictionary(lang).submit}
      />
    </form>
  )
}

export const RangeFilter = props => {
  const {
    filter: { name }
  } = props
  const { isCollapsed, setIsCollapsed } = useCollapsible({
    collapsedOnMobile: false
  })

  const accessibilityId = getId(`clps_${name}`)
  return (
    <Collapsible isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} dataTestId='range' dataValue={props.name}>
      <Collapsible.Header htmlFor={accessibilityId}>{props.filter.title}</Collapsible.Header>
      <AnimatePresence initial={false}>
        {!isCollapsed && (
          <Collapsible.Body>
            <RangeFilterItem {...props} id={accessibilityId} className='mxd-mcollapse-body' filterPosition='side' />
          </Collapsible.Body>
        )}
      </AnimatePresence>
    </Collapsible>
  )
}

function onInputChange(e) {
  return e?.target?.value?.replace(',', '.').replace(/[^\d.]/, '')
}
